import { render, staticRenderFns } from "./AccessibleBottomSheet.vue?vue&type=template&id=46717f2f&"
import script from "./AccessibleBottomSheet.vue?vue&type=script&lang=ts&"
export * from "./AccessibleBottomSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
installComponents(component, {VBottomSheet})
